import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "@components/Routes/Routes"
import { DeliveryFilesProps } from '@/propTypes';
import DeliveriesContext from '@/context/DeliveriesContext';
import { useAuth } from '@/auth/SessionAuth';
import "./App.css";

import styled from 'styled-components';

import AppHeader from '@components/Header';
import { AppFooter } from '@components/Footer';

const MainWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  [role='main'] {
    min-height: 100%;
    flex-grow: 1;
    margin: 24px 32px 32px;
  }
`;

function App() {
  const { deliveryName, apiFetch } = useAuth();
  const [delivery, setDelivery] = useState<DeliveryFilesProps>({
    files: [],
    loading: true,
  });

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const response = await apiFetch(`/${deliveryName}`);

        const data = response.ok ? await response.json() : [];
        if (active) {
          setDelivery({ files: Array.isArray(data) ? data : [], loading: false });
        }
      } catch (e) {
        if (active) {
          setDelivery({ files: [], loading: false });
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [deliveryName, apiFetch]);

  

  return (
    <MainWrapper>
      <BrowserRouter>
        <AppHeader />
        <div role="main">
          <DeliveriesContext.Provider value={delivery}>
            <Routes />
          </DeliveriesContext.Provider>
        </div>
        <AppFooter />
      </BrowserRouter>
    </MainWrapper>
  );
}

export default App;
